/**
 * Supabase Client — login REAL (W0-09, spec §11.9)
 *
 * Usado SOMENTE para autenticar (signInWithPassword, MFA/TOTP nativo do
 * GoTrue). O SDK NUNCA persiste sessão sozinho: `persistSession`/
 * `autoRefreshToken` ficam desligados porque o storage próprio do supabase-js
 * usa localStorage por padrão (spec §11.9 proíbe token persistido no browser).
 * A store real do access_token é `@/store/token-store` (memória); o refresh
 * token vai para o cookie HttpOnly via POST /bff/auth/session (bffauth.go).
 */

import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY

/** true quando as credenciais públicas do Supabase estão configuradas. */
export const supabaseAuthDisponivel = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY)

let _client: SupabaseClient | null = null

/** getSupabaseClient constrói o client sob demanda (lazy) — nunca em módulos
 * carregados quando `supabaseAuthDisponivel` é false (evita erro de init do
 * SDK com URL/chave vazias em dev-login/CI). */
export function getSupabaseClient(): SupabaseClient {
  if (!supabaseAuthDisponivel) {
    throw new Error('Supabase Auth não configurado (VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY ausentes).')
  }
  if (!_client) {
    _client = createClient(SUPABASE_URL as string, SUPABASE_ANON_KEY as string, {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
      },
    })
  }
  return _client
}
